import React from "react";
import "../AlgoTrading.css";

const Positions = () => (
  <main className="algo-page">
    <header className="algo-page-heading"><div><h1>Positions</h1><p>Monitor open and closed strategy positions.</p></div></header>
    <section className="algo-kpi-grid"><article><span>Open Positions</span><strong>0</strong></article><article><span>Invested Value</span><strong>₹0.00</strong></article><article><span>Live P&amp;L</span><strong className="algo-positive">₹0.00</strong></article></section>
    <section className="algo-content-card"><div className="algo-tabs"><button className="active">Open Positions</button><button>Closed Positions</button></div><div className="algo-empty"><i className="fa fa-briefcase"></i><h2>No open positions</h2><p>Live positions created by your strategies will appear here.</p></div></section>
  </main>
);

export default Positions;
